import Icon from '../components/Icon.vue'

Icon.register({"caret-right":{"width":192,"height":512,"paths":[{"d":"M0 384.7V127.3C0 109.5 21.5 100.6 34.1 113.2L162.8 241.9C170.6 249.7 170.6 262.3 162.8 270.1L34.1 398.8C21.5 411.4 0 402.5 0 384.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-right.js
// module id = Oncp
// module chunks = 0